import { useAppSelector } from '@energy-stacks/fleet-is/store';
import { useCacheVehicleImages } from '@energy-stacks/fleet/feature-vehicles';
import { FleetIsLogoOverlay } from '@energy-stacks/fleet-is/shared';
import { Main } from '@energy-stacks/shared';
import { AuthErrorMessage } from '@energy-stacks/user-access';
import { useLoadBrokerGoogleMapsApiScript } from '@energy-stacks/broker/shared';

import { Sidebar } from './Sidebar';

export const AppAuth = () => {
  const loginState = useAppSelector((state) => state.user.loginState);
  const { isLoaded: isGoogleMapsApiScriptLoaded } =
    useLoadBrokerGoogleMapsApiScript({
      skipFetchingGoogleApiKey: loginState !== 'loggedIn',
    });

  useCacheVehicleImages();

  if (loginState === 'error') {
    return <AuthErrorMessage />;
  }

  if (
    loginState === 'loading' ||
    loginState === 'unauthenticated' ||
    !isGoogleMapsApiScriptLoaded
  ) {
    return <FleetIsLogoOverlay />;
  }

  return (
    <Main>
      {/* <UserWelcomeDialog /> */}
      <Sidebar />
    </Main>
  );
};
